import React from 'react';
import PropTypes from 'prop-types';
import ControlP from '../../../atoms/control/ControlP';
import InputLabel from '../../../atoms/inputs/input-label';
import S3FilePicker from '../../../molecules/filepickers/s3-file-picker/S3FilePicker';
import styles from './styles.scss';
import InputContainer from '../../../atoms/inputs/input-container';
import ErrorBoundary from '../../../atoms/error-boundary';
import SubmitForm from '../../../molecules/submit-form/index.ts';

class LicenceUploadForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            frontIsValid: false,
            backIsValid: false,
        };

        this.children = React.Children
            .toArray(props.children)
            .filter((c) => {
                if (c.type) {
                    return c;
                }
                return undefined;
            });

        this.validate = this.validate.bind(this);
    }

    validate(name, error) {
        if (name === 'licenceback') {
            this.setState(() => ({
                backIsValid: !error,
            }));
        } else {
            this.setState(() => ({
                frontIsValid: !error,
            }));
        }
    }

    render() {
        const {
            frontbucketpath, frontpolicy, frontxamzcredential, frontxamzdate, frontxamzsignature,
            backbucketpath, backpolicy, backxamzcredential, backxamzdate, backxamzsignature,
        } = this.props;
        const { frontIsValid, backIsValid } = this.state;

        const invalid = !frontIsValid || !backIsValid;

        const frontValMsg = this.children.find((c) => c.props['data-valmsg-for'] === 'LicenceFront');
        const backValMsg = this.children.find((c) => c.props['data-valmsg-for'] === 'LicenceBack');

        const maxsize = 1;
        const extensions = ['.png', '.jpg', '.jpeg'];

        return (
            <ErrorBoundary>
                <SubmitForm
                    buttonLabel="Save and Review"
                    name="licence-upload"
                    isInvalid={invalid}
                    isActionsCentered
                >
                    <div className={styles['licence-upload-form']}>
                        <ControlP>
                            <InputLabel>Upload your Driver&apos;s License (Front)</InputLabel>
                            <div className={styles.filepicker}>
                                <InputContainer
                                    passerror={this.validate}
                                    required
                                    name="licencefront"
                                    displayname="Front of Licence"
                                >
                                    <S3FilePicker
                                        maxsize={maxsize}
                                        extensions={extensions}
                                        name="licencefront"
                                        bucketpath={frontbucketpath}
                                        policy={frontpolicy}
                                        xamzcredential={frontxamzcredential}
                                        xamzdate={frontxamzdate}
                                        xamzsignature={frontxamzsignature}
                                    />
                                    {frontValMsg}
                                </InputContainer>
                            </div>
                        </ControlP>
                        <ControlP>
                            <InputLabel>Upload your Driver&apos;s License (Back)</InputLabel>
                            <div className={styles.filepicker}>
                                <InputContainer
                                    passerror={this.validate}
                                    required
                                    name="licenceback"
                                    displayname="Back of Licence"
                                >
                                    <S3FilePicker
                                        maxsize={maxsize}
                                        extensions={extensions}
                                        name="licenceback"
                                        bucketpath={backbucketpath}
                                        policy={backpolicy}
                                        xamzcredential={backxamzcredential}
                                        xamzdate={backxamzdate}
                                        xamzsignature={backxamzsignature}
                                    />
                                    {backValMsg}
                                </InputContainer>
                            </div>
                        </ControlP>
                    </div>
                </SubmitForm>
            </ErrorBoundary>
        );
    }
}

LicenceUploadForm.propTypes = {
    children: PropTypes.node.isRequired,
    frontbucketpath: PropTypes.string.isRequired,
    frontpolicy: PropTypes.string.isRequired,
    frontxamzcredential: PropTypes.string.isRequired,
    frontxamzdate: PropTypes.string.isRequired,
    frontxamzsignature: PropTypes.string.isRequired,
    backbucketpath: PropTypes.string.isRequired,
    backpolicy: PropTypes.string.isRequired,
    backxamzcredential: PropTypes.string.isRequired,
    backxamzdate: PropTypes.string.isRequired,
    backxamzsignature: PropTypes.string.isRequired,
};

LicenceUploadForm.defaultProps = {
};

export default LicenceUploadForm;
